module.exports = __webpack_public_path__ + "img/5_uk.1dda42fe.svg";